import React, { useCallback } from 'react'
import cx from 'classnames'
import { HorizontalScrollProps } from './types'
import { useSidePanel } from '../SidePanel/SidePanelProvider'
import Arrow from '../Icons/Arrow'

const RIGHT_ARROW = 'right'
const LEFT_ARROW = 'left'

function HorizontalScroll({
  onHorizontalScrolling,
  heightStyle,
  canScrollLeft,
  canScrollRight = true,
}: HorizontalScrollProps) {
  const { isSidePanelOpened } = useSidePanel()
  const sidePanelModifier = isSidePanelOpened
    ? 'right-arrow--side-panel-opened'
    : 'right-arrow--side-panel-closed'
  const handleLeftClick = useCallback(
    () => onHorizontalScrolling(LEFT_ARROW),
    [onHorizontalScrolling]
  )
  const handleRightClick = useCallback(
    () => onHorizontalScrolling(RIGHT_ARROW),
    [onHorizontalScrolling]
  )

  return (
    <div className="horizontal-scrolling" style={{ height: heightStyle }}>
      {canScrollLeft && (
        <button
          type="button"
          className="hoverable-button horizontal-scrolling__left-arrow"
          onClick={handleLeftClick}
        >
          <Arrow direction="left" />
        </button>
      )}
      {canScrollRight && (
        <button
          type="button"
          className={cx(
            'hoverable-button',
            'horizontal-scrolling__right-arrow',
            sidePanelModifier
          )}
          onClick={handleRightClick}
        >
          <Arrow direction="right" />
        </button>
      )}
    </div>
  )
}

export default HorizontalScroll
